var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiLogsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-API_Logs_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "API_Logs_Active",
    "data-name": "API Logs_Active",
    clipPath: "url(#clip-API_Logs_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_Logs",
    "data-name": "API Logs",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M32.39,9.76H9.49c-1.406,0-2.55.356-2.55.793V15.76c.033-.031,1.143,0,2.55,0H34.94V10.553C34.94,10.116,33.8,9.76,32.39,9.76Z",
    transform: "translate(-5.94 -8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M33.267,31.34H9.793A3.343,3.343,0,0,1,6.53,27.932V12.748A3.343,3.343,0,0,1,9.793,9.34H18.3a.662.662,0,0,1,0,1.323H9.793a2.026,2.026,0,0,0-1.98,2.068V27.916a2.026,2.026,0,0,0,1.98,2.068H33.267a2.026,2.026,0,0,0,1.98-2.068V12.731a2.026,2.026,0,0,0-1.98-2.068H23.858a.662.662,0,0,1,0-1.323h9.409a3.343,3.343,0,0,1,3.263,3.408V27.932A3.343,3.343,0,0,1,33.267,31.34Z",
    transform: "translate(-6.53 -9.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M17.133,11.125H15.942a.882.882,0,1,1,0-1.765h1.191a.882.882,0,1,1,0,1.765Z",
    transform: "translate(-1.953 -9.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    d: "M0,0H28a0,0,0,0,1,0,0V4a2,2,0,0,1-2,2H2A2,2,0,0,1,0,4V0A0,0,0,0,1,0,0Z",
    transform: "translate(1 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(3 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_27",
    "data-name": "Subtraction 27",
    d: "M-648-604h-28v-10h28v10Zm-6.389-3.91a1.764,1.764,0,0,0,.683,1.371v.068A2.587,2.587,0,0,0-652.1-606a2.452,2.452,0,0,0,1.124-.247,1.878,1.878,0,0,0,.728-.652,1.855,1.855,0,0,0,.243-.922,1.419,1.419,0,0,0-.243-.832,1.461,1.461,0,0,0-.6-.517,5.051,5.051,0,0,0-.787-.346l-.095-.036a5.641,5.641,0,0,1-.552-.225.758.758,0,0,1-.309-.2.4.4,0,0,1-.132-.292.429.429,0,0,1,.111-.293.416.416,0,0,1,.286-.112.51.51,0,0,1,.375.135.478.478,0,0,1,.155.382h1.7a1.767,1.767,0,0,0-.64-1.327,2.38,2.38,0,0,0-1.566-.472,2.81,2.81,0,0,0-1.081.2,1.689,1.689,0,0,0-.75.607,1.639,1.639,0,0,0-.265.944,1.361,1.361,0,0,0,.242.877,1.837,1.837,0,0,0,.6.517c.232.107.511.218.9.36a3.812,3.812,0,0,1,.75.314.415.415,0,0,1,.243.383.379.379,0,0,1-.132.314.56.56,0,0,1-.354.113.612.612,0,0,1-.4-.135.561.561,0,0,1-.176-.449Zm-13.575,1.462a2.955,2.955,0,0,0,1.456.382,2.956,2.956,0,0,0,1.456-.382,2.838,2.838,0,0,0,1.058-1.057,3.178,3.178,0,0,0,.375-1.528,3.18,3.18,0,0,0-.375-1.529,2.614,2.614,0,0,0-1.037-1.056,2.94,2.94,0,0,0-1.455-.383,2.942,2.942,0,0,0-1.456.383A2.828,2.828,0,0,0-669-610.562a2.965,2.965,0,0,0-.4,1.529,2.963,2.963,0,0,0,.4,1.528,2.838,2.838,0,0,0,1.058,1.057Zm-6.036-5.42v5.757h3.331v-1.237h-1.765v-4.521Zm15.252-.111a2.983,2.983,0,0,0-1.5.383,2.53,2.53,0,0,0-1.015,1.034,2.984,2.984,0,0,0-.353,1.507,3.143,3.143,0,0,0,.353,1.528,2.518,2.518,0,0,0,1.015,1.034,2.984,2.984,0,0,0,1.5.383,2.687,2.687,0,0,0,1.236-.247,2.479,2.479,0,0,0,.9-.652,2.974,2.974,0,0,0,.552-.854v-1.552h-2.933v1.147h1.588a1.176,1.176,0,0,1-1.169.764,1.343,1.343,0,0,1-1.058-.382,1.569,1.569,0,0,1-.375-1.124,1.582,1.582,0,0,1,.331-1.057,1.182,1.182,0,0,1,.926-.383,1.084,1.084,0,0,1,.552.113.971.971,0,0,1,.374.36v-.045h1.7a2.255,2.255,0,0,0-.86-1.439A2.932,2.932,0,0,0-658.748-611.978Zm-7.737,4.429a1.174,1.174,0,0,1-.949-.405,1.537,1.537,0,0,1-.353-1.078,1.654,1.654,0,0,1,.353-1.079,1.174,1.174,0,0,1,.949-.4,1.2,1.2,0,0,1,.948.4,1.538,1.538,0,0,1,.354,1.079,1.536,1.536,0,0,1-.354,1.078A1.173,1.173,0,0,1-666.485-607.549Z",
    transform: "translate(674 612)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiLogsActive);
export default __webpack_public_path__ + "static/media/API_Logs_Active.2280d3b6a6d626a98d2f9bbf3b039468.svg";
export { ForwardRef as ReactComponent };